<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Jennifer Fallet grew up in rural Victoria, Australia in Albury–Wodonga, but life led her to work in the Navy, followed by a career in the financial sector and the information technology industry. She now resides full-time in Melbourne, Victoria, where she sees herself on a pathway of recovery learning about strategies to manage her day-to-day experiences living with a mental illness called Schizo-affective disorder and the associated challenges associated with mood, behaviour, motivation and managing finances.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?5d088eb4